import styled from '@emotion/styled';
import { TransitionStatus } from 'react-transition-group';
import { ENTERED, ENTERING } from 'react-transition-group/Transition';

import CloseIcon from '@/assets/icons/btn_modal_closed.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const transitionDuration = 225;

export const Overlay = styled.div(
  (props: { transitionStatus: TransitionStatus; baseZIndex: number }) =>
    mq({
      position: 'fixed',
      top: '0',
      left: '0',
      bottom: '0',
      overflowY: 'auto',
      width: '100%',
      height: '100%',
      backgroundColor: defaultTheme.background.overlay,
      zIndex: props.baseZIndex,
      transition: `all ${transitionDuration}ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`,
      opacity: [ENTERING, ENTERED].includes(props.transitionStatus) ? 1 : 0,
    }),
);

export const CloseButton = styled.button((props: { baseZIndex: number }) =>
  mq({
    position: 'absolute',
    right: ['16px', '16px', '24px', '24px'],
    width: ['16px', '16px', '24px', '24px'],
    height: ['16px', '16px', '24px', '24px'],
    border: 'none',
    backgroundImage: `url(${CloseIcon})`,
    backgroundSize: 'cover',
    zIndex: props.baseZIndex + 2,
    ...hoverOpacity,
  }),
);

export interface ContainerStyleProps {
  desktopWidth?: string;
  mobileWidth?: string;
  desktopHeight?: string;
  mobileHeight?: string;
  backgroundColor?: string;
  paddingSize?: string;
  radiusSize?: string;
}

export const Container = styled.div(
  (
    props: ContainerStyleProps & {
      transitionStatus: TransitionStatus;
      baseZIndex: number;
    },
  ) => {
    const dWidth = props.desktopWidth || '800px';
    const mWidth = props.mobileWidth || '95%';
    const padding = props.paddingSize || defaultTheme.spacing.xxl;
    const radius = props.radiusSize || defaultTheme.border.radius.s;

    return mq({
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      width: [mWidth, mWidth, mWidth, dWidth],
      minWidth: '320px',
      maxHeight: props.mobileHeight || 'calc(var(--vh) - 100px)',
      borderRadius: radius,
      backgroundColor: props.backgroundColor || defaultTheme.background.white,
      padding: padding,
      overflowY: 'auto',
      zIndex: props.baseZIndex + 1,
      transition: `all ${transitionDuration}ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`,
      opacity: [ENTERING, ENTERED].includes(props.transitionStatus) ? 1 : 0,
    });
  },
);
